<template>
    <el-container>
        <div class="container">
            <div class="searchBox">
                <el-form :inline="true" :model="formData" label-option="left">
                    <el-row >
                        <el-col :span="8" class="leftAlignTtem">
                            <el-form-item label="维保员">
                                <el-autocomplete
                                v-model="formData.maintainer" :fetch-suggestions="queryMaintainer">
                                </el-autocomplete>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="leftAlignTtem">
                            <el-form-item label="维保合约">
                                <el-autocomplete
                                v-model="formData.contractNo" :fetch-suggestions="queryContract">
                                </el-autocomplete>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="leftAlignTtem">
                            <el-form-item label="作番号">
                                <el-input v-model="formData.mfgNo" placeholder="作番号 模糊匹配"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </el-container>
</template>

<script>
import request from '@/lib/utils'
export default {
  name: 'SignPlan',
  data () {
    return {
      formData: {
        maintainer: '',
        contractNo: ''
      },
      maintainers: [],
      contracts: [{contractNo: 'MA001', customerName: '润景苑'}, {contractNo: 'MA002', customerName: '中心村'}, {contractNo: 'MA003', customerName: '同乐小区'}, {contractNo: 'MA004', customerName: '凯富科技园'}]
    }
  },
  methods: {
    initMaintainer () {
      request.get('/mfgManager/queryBriefMaintainer').then(res => {
        this.maintainers = res.obj
      })
    },
    initContract () {
      request.get('/mfgManager/queryBriefContract').then(res => {
        this.contracts = res.obj
      }
      )
    },
    queryMaintainer (queryString, cb) {
      let searchResults = this.maintainers
      searchResults = queryString ? searchResults.filter(item => item.name.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || item.workNo.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) : searchResults
      let cbResults = searchResults.map(item => {
        item.value = item.name + '(' + item.workNo + ')'
        return item
      })
      // console.log(cbResults)
      cb(cbResults)
    },
    queryContract (queryString, cb) {
      let searchResults = this.contracts
      searchResults = queryString ? searchResults.filter(item => item.contractNo.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || item.customerName.toLowerCase().indexOf(queryString.toLowerCase()) !== -1) : searchResults
      let cbResults = searchResults.map(item => {
        item.value = item.contractNo + '(' + item.customerName + ')'
        return item
      })
      // console.log(cbResults)
      cb(cbResults)
    }
  },
  mounted () {
    this.initMaintainer()
  }
}

</script>

<style scoped>

.container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .searchBox{
    width:80% ;
    margin-top: 40px;
  }

  .leftAlignTtem{
    text-align: left;
  }

  .contentBox{
    width: 80%;
    margin-top: 50px;
  }

  .gapRow{
    margin-top: 30px;
  }

  .el-link{
    padding-right: 10px;
  }

  .modelInput{
    width:80%
  }

  .shortInput{
    width: 30%;
  }

  .longInput{
    width: 390%;
  }

  .expandForm{
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/page/subPage/SignPlan.vue